module.exports = __webpack_public_path__ + "img/caret.63a82e99.svg";